<template>
  <div id="imageC" class="placeholder">
    <img v-if="!isLargeLoaded" :src="imageSmall" class="img-small" @load="setSmall()" :class="{ loaded: isSmallLoaded }">
    <img :src="imageLarge" @load="setLarge()" class="img-large" :class="{ loaded: isLargeLoaded }">
    <div :style="getPadding()"></div>
  </div>
</template>

<script>
export default {
  name: 'imageC',
  props: {
    imageSmall: String,
    imageLarge: String,
    paddingBottom: String, // aspect ratio percent
  },
  data() {
    return {
      isSmallLoaded: false,
      isLargeLoaded: false,
    };
  },
  methods: {
    setSmall() {
      this.isSmallLoaded = true;
    },
    setLarge() {
      this.isLargeLoaded = true;
    },
    getPadding() {
      return `padding-bottom: ${this.paddingBottom};`;
    },
  },
};
</script>

<style scoped>
.placeholder {
  background: linear-gradient(to right, #90CAF9 0%, rgba(125,185,232,0) 100%);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.placeholder img {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  transition: opacity 0s linear;
}

.placeholder img.loaded {
  opacity: 1;
}

.img-small {
  filter: blur(50px);
  /* // this is needed so Safari keeps sharp edges */
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/ImageC.vue